import { ApiClient } from '@webapp/core/services/ApiClient'
import { ShippingMethodRepository } from './ShippingMethodRepository'

export const shippingMethodRepository = new ShippingMethodRepository({
  httpClient: ApiClient,
})

export * from './ShippingMethodRepository'
